import { PropType, computed, defineComponent } from 'vue'

import { PositionType, StickyPosition } from './MsStickyContainer.enum'

export default defineComponent({
    name: 'MsStickyContainer',
    props: {
        positionType: {
            type: String as PropType<PositionType>,
            default: PositionType.STICKY,
        },
        stickyPosition: {
            type: String as PropType<StickyPosition>,
            default: StickyPosition.BOTTOM,
        },
        isVisible: {
            type: Boolean,
            default: true,
        },
        drawShadow: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const position = computed(() => {
            return {
                isTop: props.stickyPosition === StickyPosition.TOP,
                isRight: props.stickyPosition === StickyPosition.RIGHT,
                isBottom: props.stickyPosition === StickyPosition.BOTTOM,
                isLeft: props.stickyPosition === StickyPosition.LEFT,
            }
        })

        const type = computed(() => {
            return {
                isSticky: props.positionType === PositionType.STICKY,
                isFixed: props.positionType === PositionType.FIXED,
            }
        })

        return {
            position,
            type,
        }
    },
})
